var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$store.getters['UserStore/userFullName'])?_c('div',[_vm._v("\n    Hello "+_vm._s(_vm.$store.getters['UserStore/userFullName'])+" !!! :-)\n  ")]):_c('div',[_vm._v("Hello, this is a public Home Page")])])}
var staticRenderFns = []

export { render, staticRenderFns }